<template>
  <v-list dark>
    <template v-for="(item, index) in menu">
      <v-list-tile :title="item.hint" :key="item.label" :to="item.url">
        <v-list-tile-avatar>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.label }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon small>mdi-chevron-right</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider :key="index" />
    </template>
  </v-list>
</template>
<script>
import menu from '../helpers/menu'

export default {
  name: 'Navigation',
  data () {
    return {
      menu
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation.vue